<template>
  <Tooltip
    :disabled="!localModel.name"
    :content="localModel.name || ''"
    effect="dark"
  >
    <el-select
      v-bind="$attrs"
      v-model="localModel.name"
      v-tooltip
      :ref="field.name || 'dropdown'"
      :data-name="field.name"
      plain
      :popper-class="`multigroup-select`"
      :value-key="'id'"
      filterable
      no-data-text="Справочник пуст"
      no-match-text="Ничего не найдено"
      :size="size"
      :filter-method="filter"
      :required="field.required"
      :readonly="field.readonly || ''"
      :placeholder="
        hidden(field)
          ? 'Недоступно для редактирования'
          : field.placeholder || ''
      "
      :disabled="disabled(field) || field.disabled || !!hidden(field)"
      class="dropdown-el"
      :class="{
        big: size === 'big',
        medium: size === 'medium',
        small: size === 'small',
        'is-error':
          !!field.error || (simpleErrors && field.required && !localModel),
        'no-label': !!$attrs['no-label'],
        'is-readonly': !!field.readonly,
        clearable: true
      }"
      @visible-change="visibleChange"
    >
      <i
        v-if="showClearButton"
        @click="clear"
        :class="['el-input__icon el-icon-close']"
        ref="clear_icon"
      ></i>
      <component :is="`style`">
        .multigroup-select { max-width: {{ maxOptionsWidth }}; }
      </component>
      <template v-if="!Object.keys($slots).length">
        <el-option
          v-if="options.length"
          class="empty-opt"
          label=""
          value=""
        ></el-option>
        <el-tree
          v-if="options.length"
          v-tooltip
          ref="tree"
          :data="options"
          :props="props"
          node-key="id"
          :default-checked-keys="defaultCheckedKeys"
          :current-node-key="
            defaultCheckedKeys.length ? defaultCheckedKeys[0] : ''
          "
          :highlight-current="true"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          @current-change="currentChange"
        >
        </el-tree>
      </template>
    </el-select>
  </Tooltip>
</template>

<script>
import { Tree, Select, Option } from 'element-ui';
import { form, mixin, errorMsg } from '@/utils/mixins';
import { getController } from '@/controllers/request.js';
import Tooltip from 'Elements/Tooltip/Tooltip';
export default {
  mixins: [form, mixin, errorMsg],
  inheritAttrs: false,
  props: {
    field: {
      type: Object,
      default: () => ({
        name: '',
        required: false,
        placeholder: '',
        disabled: false
      })
    },
    options: {
      type: Array,
      default: () => []
    },
    model: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'big'
    },
    emitEvent: { type: String, default: 'set-value' },
    callback: {
      type: [Function, Object],
      default: null
    },
    module: String,
    label: { String, default: '' },
    simpleErrors: {
      type: Boolean, // искусственная подсветка ошибок
      default: false
    },
    clearable: {
      //временная отмашка от форм метаданных
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      defaultCheckedKeys: [],
      localModel: '',
      props: {
        label: 'name',
        children: 'children',
        disabled: 'disabled'
      },
      searchString: '',
      maxOptionsWidth: 'auto'
    };
  },
  created() {
    if (this.model) this.defaultCheckedKeys = [this.model];
    if (
      this.field.visual_type === 'multi-level' ||
      this.field.type == 'multiLevelEnum'
    ) {
      this.$emit('set-label', this.model);
    }

    this.localModel = this.findNested(this.options) || {};
  },
  mounted() {
    // задаем максимальную ширину списков опций
    const dropdownEl = this.$refs[this.field.name];
    this.maxOptionsWidth = dropdownEl
      ? dropdownEl.$el.offsetWidth + 'px'
      : 'auto';
  },
  computed: {
    showClearButton() {
      return (
        this.clearable &&
        !(this.disabled(this.field) || this.field.disabled) &&
        this.localModel != '' &&
        !this.field.readonly &&
        !this.field.disabled &&
        !(this.field.isMultiSelect || this.field.multiple)
      );
    }
  },
  methods: {
    findNested(arr = []) {
      let found = arr.find(node => node.id === this.model);
      if (found) return { ...found, name: this.label };

      for (let i = 0; i < arr.length; i++) {
        if (!arr[i].children) continue;
        const foundNested = this.findNested(arr[i].children);
        if (arr[i]?.children.length && foundNested) {
          return { ...foundNested, name: this.label };
        }
      }
    },
    filter(val) {
      this.searchString = val || '';
      this.inputPause();
    },
    inputPause() {
      if (this.inputTimer != null) clearTimeout(this.inputTimer);

      this.inputTimer = setTimeout(() => {
        if (!this.disabledByLimit)
          // await this.$emit(
          //   'filter-option',
          //   this.searchString,
          //   this.callback?.field?.input && !!this.createOptionAccess
          //     ? this.callback.field.input(
          //         this.field,
          //         this.searchString,
          //         this.createOptionAccess
          //       )
          //     : null
          // );
          this.$refs.tree.filter(this.searchString);
        this.inputTimer = null;
      }, 1000);
    },
    visibleChange(visible) {
      if (!visible) this.searchString = '';
      if (
        (this.field.visual_type === 'multi-level' ||
          this.field.type == 'multiLevelEnum') &&
        visible
      ) {
        this.$emit('filter-option');
      }
    },
    filterNode(value, data, node) {
      if (!value) return true;

      const hasFilteredParent = obj =>
        (obj.level >= 1 &&
          obj.data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1) ||
        (obj.parent && obj.parent.level >= 1 && hasFilteredParent(obj.parent));
      if (typeof data.name != 'string') return;

      if (hasFilteredParent(node.parent)) {
        this.$nextTick(() => this.$set(node, 'expanded', false));
      }
      return (
        data.name.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
        hasFilteredParent(node.parent)
      );
    },
    async handleNodeClick(node /* , tree */) {
      if (node.disabled) return;

      // запрос для получения лейбла
      const { data } = await getController({
        url: `index.php?module=${this.field?.module}&action=get_visual_value&record=${node.id}&referrer_module=${this.module}`
      });

      if (!data) return;
      if (data.error && data.status == 'error') {
        this.showErrorMessage('Возникла ошибка при обновлении значения');
        return;
      }

      this.searchString = '';
      this.localModel = {
        ...node,
        id: data.id,
        name: this.formatHtml(data.name)
      };

      this.setValue();
    },
    setValue() {
      this.$emit(
        this.emitEvent,
        this.field.name,
        this.field.visual_type === 'multi-level' ||
          this.field.type == 'multiLevelEnum'
          ? this.localModel?.id || ''
          : this.localModel?.name || '',
        this.field.blocked,
        true // для параметра trigger и вызова метода очистки по self_clean
      );
      if (
        this.field.visual_type === 'multi-level' ||
        this.field.type == 'multiLevelEnum'
      )
        this.$emit('set-label', this.localModel.name);

      if (this.callback) {
        if (this.callback && this.callback.field) {
          this.callback.field.change(
            this.field,
            this.field.visual_type === 'multi-level' ||
              this.field.type == 'multiLevelEnum'
              ? this.localModel?.id || ''
              : this.localModel?.name || '',
            this.field.blocked
          );
        } else {
          this.callback(
            this.field.visual_type === 'multi-level' ||
              this.field.type == 'multiLevelEnum'
              ? this.localModel?.id || ''
              : this.localModel?.name || ''
          );
        }
      }

      const { id_name, name } = this.field;
      this.$emit('change-option', name, id_name, this.localModel);
    },
    currentChange(/* node, tree */) {
      // через реф дерева найти текущий и заблокированный элементы и переопределить isCurrent
      // console.log('current', node, tree, this.localModel.name)
    },
    clear() {
      this.localModel = {};
      this.setValue();
      this.defaultCheckedKeys = [];
    }
    // loadNode(node, resolve) {
    //   // после подгрузки узла ставим метку loaded, чтоб при повторном клике на родителя снова не подгружать чайлдов
    //   // if (node.level === 0) {
    //     return resolve([
    //       { id: 1, name: 'Level one 1', children: [] }
    //     ]);
    //   }
    //   if (node.level > 1) return resolve([]);

    //   var hasChild;
    //   // условие по которому будем понимать что узел содержит чайлда
    //   if (
    //     !node.loaded
    //   ) {
    //     hasChild = true;
    //   } else {
    //     hasChild = false;
    //   }

    //   // запрос получения вложенных узлов
    //   if (node.loaded) return;
    //   setTimeout(() => {
    //     var data;
    //     if (hasChild) {
    //       data = [
    //         { id: this.count, name: 'Level two ', children: [] }
    //       ];
    //     } else {
    //       data = [];
    //     }

    //     node.loaded = true;

    //     resolve(data);
    //   }, 500);
    // }
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
    model: function () {
      this.localModel = this.findNested(this.options) || {};
      if (this.model) this.defaultCheckedKeys = [this.model];
    },
    showClearButton: function () {
      if (this.showClearButton) {
        setTimeout(() => {
          let input = this.$refs[this.field.name || 'dropdown'].$el;
          let clearIcon = this.$refs['clear_icon'];
          let suffixArea = input?.getElementsByClassName(
            'el-input__suffix-inner'
          )[0];
          if (clearIcon) suffixArea?.append(clearIcon);
        }, 0);
      }
    }
  },
  components: {
    'el-tree': Tree,
    'el-select': Select,
    'el-option': Option,
    Tooltip
  }
};
</script>
<style lang="scss">
.el-tree {
  &-node {
    &[aria-disabled='true'] > .el-tree-node__content > .el-tree-node__label {
      opacity: 0.5;
    }
  }
  &-node__content {
    width: 99.9%;
    margin-right: -1px;
  }

  &-node__label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &--highlight-current
    .el-tree-node.is-current[aria-disabled='true']
    > .el-tree-node__content {
    background-color: inherit;
  }
  // .is-current {
  //   background-color: $blue12;
  // }
}
// .el-select-dropdown.multigroup-select {
// display: none !important;
// }

.empty-opt {
  height: 0 !important;
  line-height: 0 !important;
}
</style>
<style lang="scss" scoped>
.el-select {
  width: 100%;

  &.clearable {
    & ::v-deep .el-input__suffix-inner {
      flex-direction: row-reverse;
    }
  }

  & ::v-deep .el-select__caret.is-reverse {
    transform: rotateZ(180deg);
  }

  & ::v-deep .el-select__caret {
    display: block;
    content: url(/style/img/big-arrow-down.svg);
    line-height: 20px;
    padding-bottom: 0 !important;
    transform: rotateZ(0deg);
  }

  & ::v-deep .el-input__inner {
    border-radius: 4px;
    font-size: 16px;
    color: $black-190;
    font-family: 'Roboto', sans-serif;
  }

  // & ::v-deep .el-input__suffix {
  //   &-inner {
  //     pointer-events: none;
  //   }
  // }

  & ::v-deep .el-input__prefix {
    left: 0 !important;

    .el-input__icon:before {
      content: '';
      width: 24px;
      height: 24px;
      display: inline-block;
      background-size: 20px 20px;
      background-repeat: no-repeat;
      background-position: center center;
      position: absolute;
      top: 50%;
      left: 12px;
      margin-top: -12px;
    }
  }

  & ::v-deep .el-icon-arrow-up::before {
    content: url('/front/public/style/img/arrow-down.svg');
  }

  & .el-input__icon.el-icon-close {
    content: url('/style/img/cross-small.svg');
    width: 16px;
    height: 16px;
    pointer-events: all;
    padding: 0;
  }

  & ::v-deep .el-input__icon {
    line-height: 20px;
    padding-bottom: 2px;
  }

  & ::v-deep &__input {
    border: none;
    background-color: inherit;
  }
}

.el-select-dropdown.el-popper {
  font-family: Roboto, sans-serif;
}

.dropdown-el__option {
  font-family: 'Roboto', sans-serif;

  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;

    span {
      overflow: hidden;
      text-overflow: ellipsis;
    }

    svg {
      cursor: pointer;
    }
  }

  &.is-disabled {
    color: $black-50 !important;

    &:hover {
      background-color: unset;
    }

    & ::v-deep span {
      pointer-events: none;
    }
  }
}
</style>
